// ReduxFile.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BRANCH } from "constants/AuthConstant";
import GroupMenuService from "services/GroupMenuService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  result: {},
  groupMenuList: {},
  refreshList: false,
  getCount: {},
  branchId: 0,
};


export const getGroupMenuList = createAsyncThunk(
  "groupMenu/getGroupMenuList",
  async (_, { rejectWithValue, getState }) => {
    try {
      const { branchId } = getState().groupMenu; 
      const response = await GroupMenuService.getUserMenuList(branchId);
      if (response.status === 201 || response.status === 200) {
        console.log("cek json : ", response.data.submenu);
        console.log("cek json : ", typeof response.data.submenu);
        if (response.data.submenu != null) {
          notification.success({
            message: "Success",
            description: "Get Group menu Success",
            duration: 1,
          });
        } else {
          notification.error({
            message: "Error",
            description: "Unexpected response!",
            duration: 1,
          });
        }
        return response || "No Response";
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 1,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 1,
      });
      return rejectWithValue(error.response?.data.message || "Catched error!");
    }
  }
);

export const GroupMenuSlice = createSlice({
  name: "groupMenu",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      localStorage.setItem(BRANCH, JSON.stringify(action.payload));
    },
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGroupMenuList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getGroupMenuList.fulfilled, (state, action) => {
        state.loading = false;
        state.groupMenuList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getGroupMenuList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, showLoading, authenticated } =
  GroupMenuSlice.actions;

export default GroupMenuSlice.reducer;
